import { onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";
import { auth, db } from "../pagini/Firebase";
import { collection, query, where, getDocs } from "firebase/firestore";

const useAuthInfo = () => {
  const [userEmail, setUserEmail] = useState("");
  const [userRole, setUserRole] = useState("");
  const [userFullName, setUserFullName] = useState("");
  const [institutie, setInstitutie] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          setUserEmail(user.email || "");

          // Caută userul în Firestore după email
          const q = query(
            collection(db, "Utilizatori"),
            where("email", "==", user.email)
          );
          const querySnapshot = await getDocs(q);

          if (!querySnapshot.empty) {
            const userData = querySnapshot.docs[0].data();
            const nume = userData.nume || "";
            const prenume = userData.prenume || "";
            const institutieUser = userData.institutie || "";
            const roleFromFirestore = userData.role|| "neidentificat";

            setUserFullName(`${prenume} ${nume}`.trim());
            setInstitutie(institutieUser);
            setUserRole(roleFromFirestore);
          } else {
            // Dacă nu găsește în Firestore, resetează datele
            setUserFullName("");
            setInstitutie("");
            setUserRole("user");
          }
        } catch (err) {
          console.error("❌ Eroare la Firestore:", err);
          setUserEmail("");
          setUserRole("");
          setUserFullName("");
          setInstitutie("");
        }
      } else {
        setUserEmail("");
        setUserRole("");
        setUserFullName("");
        setInstitutie("");
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return { userEmail, userRole, userFullName, institutie, loading };
};

export default useAuthInfo;
